import api_client from "../../utils/api_client";

const idempotencyKey = () => globalThis.crypto?.randomUUID?.() ?? `action-${Date.now()}-${Math.random()}`;

//後端以 4xx/5xx 回傳的 {error, msg} 也要讓頁面拿得到，不然只會看到「連線失敗」
const unwrap = async (promise) => {
  try {
    const response = await promise;
    return response.data;
  } catch (error) {
    const data = error?.response?.data;
    if (data && typeof data === "object" && "error" in data) return data;
    throw error;
  }
};

export const quoteKioskOrder = (payload) => unwrap(api_client.post("/kiosk/quote", payload));

export const createKioskOrder = (payload) => {
  const key = idempotencyKey();
  return unwrap(api_client.post("/kiosk/orders", {...payload, idempotency_key: key}, {
    headers: {"Idempotency-Key": key},
  }));
};

export const payKioskOrderWithLine = ({orderId, sessionId, lineCode}) => {
  const key = idempotencyKey();
  return unwrap(api_client.post(`/kiosk/orders/${orderId}/line-pay`, {
    session_id: sessionId,
    line_code: lineCode,
    idempotency_key: key,
  }, {headers: {"Idempotency-Key": key}}));
};

export const getKioskOrderStatus = ({orderId, sessionId}) =>
  unwrap(api_client.get(`/kiosk/orders/${orderId}/status`, {params: {session_id: sessionId}}));

export const cancelKioskOrder = ({orderId, sessionId}) =>
  unwrap(api_client.post(`/kiosk/orders/${orderId}/cancel`, {session_id: sessionId}));

export const verifyKioskStaffPin = (pin) => unwrap(api_client.post("/kiosk/staff/verify", {pin}));

//折扣碼查驗（共用 POS 轉盤券查詢）
export const checkKioskCoupon = (code) => unwrap(api_client.get("/coupon", {params: {code}}));
